export default () => ({
  '::after': {
    display: 'block',
    visibility: 'hidden',
    clear: 'both',

    height: '0',

    content: '\'\''
  }
})



// WEBPACK FOOTER //
// ./styles/tools/clearfix.js